export const sessionStorageService = {
  setItem(name, item) {
    return sessionStorage.setItem(name, JSON.stringify(item))
  },

  getItem(name) {
    return JSON.parse(sessionStorage.getItem(name))
  }
}
